/**
 * Inside-Syria prices are shown in New Syrian Pounds.
 * Owner-set conversion rate, shared by every checkout surface.
 */
export const SYP_RATE = 135;

export function sypAmount(priceUsd: number): number {
  return Math.round(Number(priceUsd) * SYP_RATE);
}

export function formatSypPrice(priceUsd: number): string {
  return String(sypAmount(priceUsd));
}
